<cc-icon
    [icon]="'list'"
    [size]="'medium'"
    [color]="'var(--grid-action-color)'"
    [highlight]="hovered"
    (iconClicked)="pressed.emit()"
>
</cc-icon>
<span class="note-label">{{ label }}</span>
